import { BaseRouteService } from 'core/services';

class ScheduledJobLogRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'alerts/';
	}

	findScheduledJobLogs(filter) {
		return super.create(this.base + 'find-scheduled-job-logs', filter);
	}
}

export default ScheduledJobLogRouteService;
